import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { SEQUENCES_LIST_KEY } from './useSequencesFolders';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export default function useDeleteSequence() {
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['sequence']);
  const { mutateAsync } = useMutation({
    mutationFn: ({ sequenceId }: { sequenceId: string }) =>
      request(`/sequences/${sequenceId}`, {
        method: 'DELETE',
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('sequence:messages.sequence.deleteError'),
      });
    },
  });
  return mutateAsync;
}
